import { Navigate, Routes, Route } from "react-router";
import Organizations from '../pages/admin/Organizations';
import O365Licenses from '../pages/admin/O365/O365Licenses';
import ESET from '../pages/admin/ESET/ESET';
import O365Users from '../pages/admin/O365/O365Users';
import O365Dashboard from '../pages/admin/O365/O365Dashboard';
import EsetLicenses from '../pages/admin/ESET/EsetLicenses';
import { Box } from '@mui/material';
import PermissionGuard from '../components/PermissionGuard';
import VBO from '../pages/admin/VBO/VBO';
import VBO365Licenses from '../pages/admin/VBO/VBO365Licenses';
import VBO365Users from '../pages/admin/VBO/VBO365Users';
import EsetDevices from '../pages/admin/ESET/EsetDevices';
import SignIn from '../pages/admin/Authentification/SignIn';
import HistoryLog from '../pages/admin/HistoryLog';
import Domain from '../pages/admin/Domain';
import Centreon from '../pages/admin/CENTREON/Centreon';
import Contrats from '../pages/admin/Contrats';
import Quotes from '../pages/admin/Administratif/Quotes';
import Tickets from '../pages/admin/Tickets/Tickets';
import NotFound from '../pages/admin/NotFound';
import ContratDetails from '../pages/admin/ContratDetails';
import Signitic from '../pages/admin/Signitic/Signitic';
import QuoteSign from '../pages/admin/Administratif/QuoteSign';
import ContratMatrix from '../pages/admin/ContratMatrix';
import OAuthSuccess from '../pages/admin/OAuthSuccess';
import ImportMain from '../pages/admin/Import/ImportMain';
import Home from '../pages/admin/Home';
import Users from "../pages/admin/Users";
import Products from "../pages/admin/Products";
import Mc3Products from "../pages/admin/MC3Cloud/MC3Product";
import TimeEntryERM from "../pages/admin/Tickets/TimeEntryERM";
import IK from "../pages/admin/Tickets/IK";
import ContratListePage from "../pages/admin/Administratif/Contrat/V2/ContratListePage";
import Contrat from "../pages/admin/Administratif/Contrat/Contrat";
// import ContratListePage from "../pages/admin/Administratif/Contrat/ContratListePlage";
import ContratMatrixPage from "../pages/admin/Administratif/Contrat/V2/ContratMatrixPage";
import RapportAnnuelPage from "../pages/admin/Administratif/Contrat/V2/RapportAnnuelPage";
import RapportMensuelPage from "../pages/admin/Administratif/Contrat/V2/RapportMensuelPage";
import ContratDashboard from "../pages/admin/Administratif/Contrat/V2/ContratDashboard";
import IKGlobal from "../pages/admin/Tickets/IKGlobal";
import ReportADVPage from "../pages/admin/Administratif/ReportADVPage";
import FacturesPage from "../pages/admin/Administratif/Factures";
import StaffPortfolioPage from "../pages/admin/StaffPortfolioPage";
import PermissionsPage from "../pages/admin/Permissions/PermissionsPage";
import LevelDevicesPage from "../pages/admin/Level/LevelDevicesPage";
import SettingsPage from "../pages/admin/Settings/SettingsPage";
// import ContratMensuelPage from "../pages/admin/Administratif/Contrat/ContratMensuelPage";
// import ContratAnnuelPage from "../pages/admin/Administratif/Contrat/ContratAnnuelPage";

function MainViewAdmin({ data }) {
  const secure = (permission, element) => (
    <PermissionGuard permission={permission}>
      {element}
    </PermissionGuard>
  );

  return (
    <Box sx={{ width: '100%',  }}>
    <Routes>
        <Route path="organizations">
          <Route index element={secure("view.organizations", <Organizations />)} />
          <Route path="users" element={secure("view.organizations.users", <Users />)} />
          <Route path="portfolio" element={secure("view.organizations.portfolio", <StaffPortfolioPage />)} />
        </Route>
        
        <Route path="home" element={secure("view.home", <Home />)} />  
        <Route path="products" element={secure("view.products", <Products />)} />  
        <Route path="reports" element={secure("view.reports", <ReportADVPage />)} />  
        <Route path="mc3cloud/products" element={secure("view.mc3.products", <Mc3Products />)} />  

        <Route path="o365" element={secure("view.o365", <O365Dashboard />)} />  
        <Route path="o365/licenses" element={secure("view.o365.licenses", <O365Licenses />)} />  
        <Route path="o365/users" element={secure("view.o365.users", <O365Users />)} /> 

        <Route path="eset" element={secure("view.eset", <ESET />)} />  
        <Route path="eset/licenses" element={secure("view.eset.licenses", <EsetLicenses />)} />  
        <Route path="eset/devices" element={secure("view.eset.devices", <EsetDevices />)} />  

        <Route path="history" element={secure("view.history", <HistoryLog />)} /> 

        <Route path="vbo365" element={secure("view.vbo365", <VBO />)} />  
        <Route path="vbo365/licenses" element={secure("view.vbo365.licenses", <VBO365Licenses />)} />  
        <Route path="vbo365/users" element={secure("view.vbo365.users", <VBO365Users />)} />  

        <Route path="domain" element={secure("view.domains", <Domain />)} />  
        <Route path="import" element={secure("view.import", <ImportMain />)} />  
        <Route path="tickets" element={secure("view.tickets", <Tickets />)} />  
        <Route path="tickets/timeEntry" element={secure("view.tickets.time", <TimeEntryERM />)} />  
        <Route path="tickets/myik" element={secure("view.tickets.myik", <IK />)} />  
        <Route path="tickets/ik" element={secure("view.tickets.ik", <IKGlobal />)} />  

        <Route path="centreon" element={secure("view.centreon", <Centreon />)} />  
        <Route path="level/devices" element={secure("view.level.devices", <LevelDevicesPage />)} />  
        {/* <Route path="contrats" element={<Contrats  />} />   */}
        {/* <Route path="contrats/:id" element={<ContratDetails  />} />   */}
        <Route path="easyredmine" element={<Tickets  />} />  

        <Route path="auth" element={<SignIn />} />  
        <Route path="quotes" element={secure("view.quotes", <Quotes />)} />  
        <Route path="*" element={<NotFound />} />

        <Route path="quotes" >
          <Route index element={secure("view.quotes", <Quotes />)} />
          {/* <Route path=":id" element={<Quotes />} />   */}
          <Route path="form" element={secure("view.quotes", <QuoteSign />)} />  
        </Route>



         <Route path="contrats">
          <Route index element={secure("view.contracts", <ContratDashboard />)} />
          <Route path="matrix" element={secure("view.contracts.matrix", <ContratMatrixPage />)} /> 
          <Route path="list" element={secure("view.contracts.list", <ContratListePage />)} /> 
          <Route path="annual" element={secure("view.contracts.annual", <RapportAnnuelPage />)} />
          <Route path="monthly" element={secure("view.contracts.monthly", <RapportMensuelPage />)} />
          {/* <Route path="matrix" element={secure("view.contracts.matrix", <ContratMatrixPage />)} />  */}
          {/* <Route path="monthly" element={<ContratMensuelPage />} />
          <Route path=":id" element={<ContratDetails />} /> */}
          
        </Route>

        <Route path="signitic" element={secure("view.signitic", <Signitic />)} />
        <Route path="factures" element={secure("view.invoices", <FacturesPage />)} />
        <Route path="settings">
          <Route index element={<Navigate to="general" replace />} />
          <Route path="general" element={secure("view.settings", <SettingsPage section="general" />)} />
          <Route path="permissions" element={secure("view.permissions", <SettingsPage section="permissions" />)} />
          <Route path="signitic" element={secure("view.settings", <SettingsPage section="signitic" />)} />
          <Route path="eset" element={secure("view.settings", <SettingsPage section="eset" />)} />
          <Route path="level" element={secure("view.settings", <SettingsPage section="level" />)} />
          <Route path="cron" element={secure("view.settings", <SettingsPage section="cron" />)} />
        </Route>
        <Route path="permissions" element={secure("view.permissions", <PermissionsPage />)} />

        {/* <Route path="eset/devices" element={<ESETDevices />} />   */}
    </Routes>
    </Box>
  )
}

export default MainViewAdmin